import $ from 'jquery';
import { MetaRouter } from '../utils/metarouter';

export default ($el) => {
    const $panels = $el.find('.image-panel__panel');

    $panels.on('click', (e) => {
        MetaRouter.sendTrackEvent('cta_tapped', {
            app: 'web-site',
            location_on_page: 'image_panel_section',
            screen_name: 'home_page',
            component: 'image-panel',
            funnel_name: 'regular',
            button_name: $(e.target).find('h2')[0].innerText,
        });
    });
};
